<style scoped>
.cards .card {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 150px;
  margin: 1em 2em;
  -moz-transition: opacity 0.5s;
  -o-transition: opacity 0.5s;
  -webkit-transition: opacity 0.5s;
  transition: opacity 0.5s;
}
.cards .card .front,
.cards .card .back {
  border-radius: 5px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: White;
  -moz-backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -moz-transition: -moz-transform 0.6s;
  -o-transition: -o-transform 0.6s;
  -webkit-transition: -webkit-transform 0.6s;
  transition: transform 0.6s;
  -moz-transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.cards .card .back {
  background-image: url("../../public/game/cards/back.jpg");
  background-size: 90%;
  background-position: center;
  background-repeat: no-repeat;
  font-size: 12px;
}
.cards .card .front {
  -moz-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  -webkit-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;
}
.cards .card.flipped .back,
.cards .card.found .back {
  -moz-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.cards .card.flipped .front,
.cards .card.found .front {
  -moz-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.cards .card.found {
  opacity: 0.3;
}
@media only screen and (max-width: 800px) {
  .cards .card {
    /* position: relative;
    display: inline-block;*/
    width: 65px;
    height: 90px;
    margin: 0.1em 0.1em;
  }
}
</style>
<template>
  <div>
    <h3>
      ¡Encuentra el objeto extraviado!
    </h3>
    <p>
      Resuelve el memorama para recuperarlo.
    </p>
    <div class="cards">
      <div class="card" v-for="(card, index) in cards" :key="index" :class="{ flipped: card.flipped, found: card.found }" @click="flipCard(card)">
        <div class="back"></div>
        <div class="front" :style="{ backgroundImage: 'url(' + card.image + ')' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */

import _ from "lodash";
import moment from "moment";

export default {
  name: "Memoria",
  data() {
    return {
      showSplash: false,
      cards: [],
      started: false,
      startTime: 0,
      turns: 0,
      fails: 0,
      corrects: 0,
      flipBackTimer: null,
      timer: null,
      time: "--:--",
      score: 0,
      cardTypes: {
        mark1: [
          {
            name: "vue",
            image: "game/cards/acta/c1.jpg"
          },
          {
            name: "vue",
            image: "game/cards/acta/c1e.jpg"
          },
          {
            name: "express",
            image: "game/cards/acta/c2.jpg"
          },
          {
            name: "express",
            image: "game/cards/acta/c2e.jpg"
          },
          {
            name: "mongo",
            image: "game/cards/acta/c3.jpg"
          },
          {
            name: "mongo",
            image: "game/cards/acta/c3e.jpg"
          },
          {
            name: "nodejs",
            image: "game/cards/acta/c4.jpg"
          },
          {
            name: "nodejs",
            image: "game/cards/acta/c4e.jpg"
          },
          {
            name: "webpack",
            image: "game/cards/acta/c5.jpg"
          },
          {
            name: "webpack",
            image: "game/cards/acta/c5e.jpg"
          },
          {
            name: "npm",
            image: "game/cards/acta/c6.jpg"
          },
          {
            name: "npm",
            image: "game/cards/acta/c6e.jpg"
          }
        ], 
        mark2: [        
          {
            name: "vue",
            image: "game/cards/penacho/c1.jpg"
          },
          {
            name: "vue",
            image: "game/cards/penacho/c1e.jpg"
          },
          {
            name: "express",
            image: "game/cards/penacho/c2.jpg"
          },
          {
            name: "express",
            image: "game/cards/penacho/c2e.jpg"
          },
          {
            name: "mongo",
            image: "game/cards/penacho/c3.jpg"
          },
          {
            name: "mongo",
            image: "game/cards/penacho/c3e.jpg"
          },
          {
            name: "nodejs",
            image: "game/cards/penacho/c4.jpg"
          },
          {
            name: "nodejs",
            image: "game/cards/penacho/c4e.jpg"
          },
          {
            name: "webpack",
            image: "game/cards/penacho/c5.jpg"
          },
          {
            name: "webpack",
            image: "game/cards/penacho/c5e.jpg"
          },
          {
            name: "npm",
            image: "game/cards/penacho/c6.jpg"
          },
          {
            name: "npm",
            image: "game/cards/penacho/c6e.jpg"
          }
        ], 
        mark3: [
          {
            name: "vue",
            image: "game/cards/sorjuana/c1.jpg"
          },
          {
            name: "vue",
            image: "game/cards/sorjuana/c1e.jpg"
          },
          {
            name: "express",
            image: "game/cards/sorjuana/c2.jpg"
          },
          {
            name: "express",
            image: "game/cards/sorjuana/c2e.jpg"
          },
          {
            name: "mongo",
            image: "game/cards/sorjuana/c3.jpg"
          },
          {
            name: "mongo",
            image: "game/cards/sorjuana/c3e.jpg"
          },
          {
            name: "nodejs",
            image: "game/cards/sorjuana/c4.jpg"
          },
          {
            name: "nodejs",
            image: "game/cards/sorjuana/c4e.jpg"
          },
          {
            name: "webpack",
            image: "game/cards/sorjuana/c5.jpg"
          },
          {
            name: "webpack",
            image: "game/cards/sorjuana/c5e.jpg"
          },
          {
            name: "npm",
            image: "game/cards/sorjuana/c6.jpg"
          },
          {
            name: "npm",
            image: "game/cards/sorjuana/c6e.jpg"
          }
        ]
      }
    };
  },
  props: {
    title: {
      type: String,
      default: "¡Alguien se robó un cuadro!"
    },
    markId: {
      type: String,
      default: "mark2"
    }
  },
  methods: {
    shuffleCards() {
      const ct = this.cardTypes[this.markId] ?? [];
      const cards = [].concat(_.cloneDeep(ct));
      return _.shuffle(cards);
    },
    resetGame() {
      this.showSplash = false;
      const cards = this.shuffleCards();
      this.turns = 0;
      this.fails = 0;
      this.corrects = 0;
      this.score = 0;
      this.started = false;
      this.startTime = 0;

      _.each(cards, card => {
        card.flipped = false;
        card.found = false;
      });

      this.cards = cards;
    },

    flippedCards() {
      return _.filter(this.cards, card => card.flipped);
    },

    sameFlippedCard() {
      const flippedCards = this.flippedCards();
      if (flippedCards.length === 2) {
        if (flippedCards[0].name === flippedCards[1].name) {
          return true;
        }
      }
      return false;
    },

    setCardFounds() {
      _.each(this.cards, card => {
        if (card.flipped) {
          card.found = true;
        }
      });
    },

    checkAllFound() {
      const foundCards = _.filter(this.cards, card => card.found);
      if (foundCards.length === this.cards.length) {
        return true;
      }
      return false;
    },

    startGame() {
      this.started = true;
      this.startTime = moment();

      this.timer = setInterval(() => {
        this.time = moment(moment().diff(this.startTime)).format("mm:ss");
      }, 1000);
    },

    finishGame() {
      this.started = false;
      clearInterval(this.timer);
      const score = 1000;
      // - (moment().diff(this.startTime, "seconds") - CardTypes.length * 5) * 3
      // - (this.turns - CardTypes.length) * 5;
      this.score = Math.max(score, 0);
      this.showSplash = true;
      this.$emit("onFinishGame", true);
    },

    flipCard(card) {
      if (card.found || card.flipped) return;

      if (!this.started) {
        this.startGame();
      }

      const flipCount = this.flippedCards().length;
      if (flipCount === 0) {
        card.flipped = !card.flipped;
      }
      else if (flipCount === 1) {
        card.flipped = !card.flipped;
        this.turns += 1;

        if (this.sameFlippedCard()) {
          // Match!
          this.corrects += 1;
          this.flipBackTimer = setTimeout(() => {
            this.clearFlipBackTimer();
            this.setCardFounds();
            this.clearFlips();

            if (this.checkAllFound()) {
              this.finishGame();
            }
          }, 200);
        }
        else {
          // Wrong match
          this.fails += 1;
          this.flipBackTimer = setTimeout(() => {
            this.clearFlipBackTimer();
            this.clearFlips();
          }, 1000);
        }
        const stats = {
          turns: this.turns,
          corrects: this.corrects,
          fails: this.fails
        };
        this.$emit("onStatsChanged", stats);
      }
    },

    clearFlips() {
      _.map(this.cards, card => {
        card.flipped = false;
        return card;
      });
    },

    clearFlipBackTimer() {
      clearTimeout(this.flipBackTimer);
      this.flipBackTimer = null;
    }
  },
  mounted() {
    this.resetGame();
  }
};
</script>
